// macadamia-app/src/macadamia-core/components/PlaceholderBlock.tsx
import React from 'react';
import Microphone from '../../macadamia-core/icons/Microphone';

interface PlaceholderBlockProps {
  onCreateBlock: () => void;
  onStartDictation?: () => void;
  isDictating?: boolean;
  isDictationTranscribing?: boolean;
}

const PlaceholderBlock: React.FC<PlaceholderBlockProps> = ({
  onCreateBlock,
  onStartDictation,
  isDictating,
  isDictationTranscribing,
}) => {
  return (
    <div
      className="
        p-0
        duration-200
        flex
        items-center
        gap-4
      "
    >
      <span
        onClick={onCreateBlock}
        className="text-gray-400 dark:text-gray-500 italic select-none cursor-pointer"
      >
        Écrire...
      </span>

      {onStartDictation && (
        <>
          <span className="text-gray-300 dark:text-gray-600 select-none">|</span>
          <span
            onClick={(e) => {
              e.stopPropagation();
              onStartDictation();
            }}
            className={`flex items-center gap-1.5 italic select-none cursor-pointer transition-colors ${
              isDictating
                ? 'text-red-500 dark:text-red-400'
                : isDictationTranscribing
                  ? 'text-mcdm-secondary-400 dark:text-mcdm-secondary-300'
                  : 'text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400'
            }`}
          >
            <span className={`inline-flex ${isDictating ? 'animate-pulse' : ''}`}>
              <Microphone width="14" height="14" />
            </span>
            {isDictating
              ? 'Dictée en cours...'
              : isDictationTranscribing
                ? 'Transcription...'
                : 'Ou dicter'}
          </span>
        </>
      )}
    </div>
  );
};

export default PlaceholderBlock;
